var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../../sutl';
import { getInitialVideoInput, } from '../framework/Emulator';
import { EmulatorTvTuner } from '../framework/EmulatorTvTuner';
import { Timeouts } from '../framework/Timeouts';
const applicationNames = [
    'amazon',
    'hulu',
    'netflix',
    'pandora',
    'vudu',
    'webBrowser',
    'youTube',
];
const inputSources = [
    'AV1',
    'COMPONENT1',
    'HDMI1',
    'HDMI2',
    'HDMI3',
    'HDMI4',
    'TV',
    'USB',
];
export class SamsungProTv {
    constructor() {
        this.accessToken = '';
        this.headers = {
            server: 'Samsung IP Control Server/1.0',
            'okhttp-response-source': 'NETWORK 200',
            'okhttp-selected-protocol': 'http/1.1',
            'content-type': 'application/json; charset="utf-8"',
        };
        this.power = false;
        this.timeouts = new Timeouts();
        this.inputSource = 'HDMI1';
        this.tv = new EmulatorTvTuner();
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                path: /.+/,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9;
                    switch ((_b = (_a = req.data) === null || _a === void 0 ? void 0 : _a.method) !== null && _b !== void 0 ? _b : 'error') {
                        case 'channelUpDnControl':
                            if (((_d = (_c = req.data) === null || _c === void 0 ? void 0 : _c.params) === null || _d === void 0 ? void 0 : _d.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_f = (_e = req.data) === null || _e === void 0 ? void 0 : _e.params) === null || _f === void 0 ? void 0 : _f.control) === undefined ||
                                (req.data.params.control !== 'channelDn' &&
                                    req.data.params.control !== 'channelUp')) {
                                return this.makeUnknownError(req);
                            }
                            else if (this.inputSource !== 'TV') {
                                return this.makeInvalidOperationError(req);
                            }
                            else {
                                if (req.data.params.control === 'channelUp') {
                                    this.tv.channelUp();
                                }
                                else {
                                    this.tv.channelDown();
                                }
                                return this.makeResponse(req, {
                                    control: req.data.params.control,
                                });
                            }
                        case 'createAccessToken':
                            yield this.timeouts.delay(3000);
                            this.accessToken = this.createAccessToken();
                            return this.makeResponse(req, { AccessToken: this.accessToken }, true);
                        case 'directAccessControl':
                            if (((_h = (_g = req.data) === null || _g === void 0 ? void 0 : _g.params) === null || _h === void 0 ? void 0 : _h.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_k = (_j = req.data) === null || _j === void 0 ? void 0 : _j.params) === null || _k === void 0 ? void 0 : _k.applicationName) !== undefined) {
                                if (!applicationNames.includes(req.data.params.applicationName)) {
                                    return this.makeInvalidOperationError(req);
                                }
                                this.applicationName = req.data.params.applicationName;
                            }
                            if (this.applicationName === undefined) {
                                return this.makeUnknownError(req);
                            }
                            else {
                                return this.makeResponse(req, {
                                    applicationName: this.applicationName,
                                });
                            }
                        case 'directChannelControl':
                            if (((_m = (_l = req.data) === null || _l === void 0 ? void 0 : _l.params) === null || _m === void 0 ? void 0 : _m.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (this.inputSource !== 'TV') {
                                return this.makeInvalidOperationError(req);
                            }
                            if (((_p = (_o = req.data) === null || _o === void 0 ? void 0 : _o.params) === null || _p === void 0 ? void 0 : _p.channelNum) !== undefined) {
                                const ch = req.data.params.channelNum.split('-');
                                const major = Math.min(Math.max(parseInt(ch[0], 10), 1), 999);
                                const minor = Math.min(Math.max(ch[1] ? parseInt(ch[1], 10) : 1, 1), 999);
                                this.tv.channelSet(major, minor);
                            }
                            return this.makeResponse(req, {
                                airCable: '',
                                atvDtv: 'DTV',
                                channelNum: `${this.tv.channel.major}-${this.tv.channel.minor}`,
                                RFtype: 'AIR',
                            });
                        case 'directVolumeControl':
                            if (((_r = (_q = req.data) === null || _q === void 0 ? void 0 : _q.params) === null || _r === void 0 ? void 0 : _r.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_t = (_s = req.data) === null || _s === void 0 ? void 0 : _s.params) === null || _t === void 0 ? void 0 : _t.volume) !== undefined) {
                                const volume = parseInt(req.data.params.volume, 10);
                                if (Number.isNaN(volume) || volume < 0 || volume > 100) {
                                    return this.makeInvalidOperationError(req);
                                }
                                this.volume = volume;
                            }
                            return this.makeResponse(req, { volume: this.volume.toString() });
                        case 'inputSourceControl':
                            if (((_v = (_u = req.data) === null || _u === void 0 ? void 0 : _u.params) === null || _v === void 0 ? void 0 : _v.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_x = (_w = req.data) === null || _w === void 0 ? void 0 : _w.params) === null || _x === void 0 ? void 0 : _x.inputSource) !== undefined) {
                                if (!inputSources.includes(req.data.params.inputSource)) {
                                    return this.makeInvalidOperationError(req);
                                }
                                this.inputSource = req.data.params.inputSource;
                                this.applicationName = undefined;
                            }
                            return this.makeResponse(req, { inputSource: this.inputSource });
                        case 'muteControl':
                            if (((_z = (_y = req.data) === null || _y === void 0 ? void 0 : _y.params) === null || _z === void 0 ? void 0 : _z.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_1 = (_0 = req.data) === null || _0 === void 0 ? void 0 : _0.params) === null || _1 === void 0 ? void 0 : _1.mute) !== undefined) {
                                if (req.data.params.mute === 'muteOff') {
                                    this.volumeMute = false;
                                }
                                else if (req.data.params.mute === 'muteOn') {
                                    this.volumeMute = true;
                                }
                                else {
                                    return this.makeInvalidOperationError(req);
                                }
                            }
                            return this.makeResponse(req, {
                                mute: this.volumeMute ? 'muteOn' : 'muteOff',
                            });
                        case 'powerControl':
                            if (((_3 = (_2 = req.data) === null || _2 === void 0 ? void 0 : _2.params) === null || _3 === void 0 ? void 0 : _3.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_5 = (_4 = req.data) === null || _4 === void 0 ? void 0 : _4.params) === null || _5 === void 0 ? void 0 : _5.power) !== undefined) {
                                if (req.data.params.power === 'powerOff') {
                                    this.power = false;
                                }
                                else if (req.data.params.power === 'powerOn') {
                                    this.power = true;
                                }
                                else {
                                    return this.makeInvalidOperationError(req);
                                }
                            }
                            return this.makeResponse(req, {
                                power: this.power ? 'powerOn' : 'powerOff',
                            });
                        case 'remoteKeyControl':
                            if (((_7 = (_6 = req.data) === null || _6 === void 0 ? void 0 : _6.params) === null || _7 === void 0 ? void 0 : _7.AccessToken) !== this.accessToken) {
                                return this.makeParseError();
                            }
                            if (((_9 = (_8 = req.data) === null || _8 === void 0 ? void 0 : _8.params) === null || _9 === void 0 ? void 0 : _9.remoteKey) === undefined) {
                                return this.makeUnknownError(req);
                            }
                            else {
                                return this.makeResponse(req, {
                                    remoteKey: req.data.params.remoteKey,
                                });
                            }
                        default:
                            break;
                    }
                    return this.makeInvalidOperationError(req);
                }),
            },
        ];
    }
    onConfigure(config) {
        var _a;
        const current = (_a = this.applicationName) !== null && _a !== void 0 ? _a : this.inputSource;
        const input = getInitialVideoInput(current, config);
        if (applicationNames.includes(input)) {
            this.applicationName = input;
        }
        else {
            this.inputSource = input;
            this.applicationName = undefined;
        }
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
    onInitialize(storage) {
        var _a;
        this.accessToken = (_a = storage.accessToken) !== null && _a !== void 0 ? _a : this.createAccessToken();
    }
    createAccessToken() {
        return Sutl.generateRandomString(49, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    }
    makeError(id, code, message, data) {
        const headers = Object.assign(Object.assign({}, this.headers), { connection: 'close' });
        if (data === undefined) {
            const resp = {
                status: 200,
                headers,
                data: {
                    code,
                    message,
                },
            };
            if (id !== undefined)
                resp.data.id = id.toString();
            return resp;
        }
        else {
            const resp = {
                status: 200,
                headers,
                data: {
                    error: {
                        code,
                        data,
                        message,
                    },
                },
            };
            if (id !== undefined)
                resp.data.id = id.toString();
            return resp;
        }
    }
    makeInvalidOperationError(request) {
        var _a;
        return this.makeError((_a = request.data) === null || _a === void 0 ? void 0 : _a.id, -32003, 'Server error', 'Invalid operation');
    }
    makeParseError() {
        return this.makeError(undefined, -32700, 'Parse error');
    }
    makeResponse(request, result, error = false) {
        var _a, _b;
        return {
            status: 200,
            headers: this.headers,
            data: {
                id: (_b = (_a = request.data) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString(),
                jsonrpc: '2.0',
                result,
            },
        };
    }
    makeUnknownError(request) {
        var _a;
        return this.makeError((_a = request.data) === null || _a === void 0 ? void 0 : _a.id, -32000, 'Server error', 'Unknown');
    }
}
SamsungProTv.emulatorType = 'httpRequestEmulator';
SamsungProTv.key = '-MVIScyKrq9G-ARWbrSv';
